import {
    addAnswers,
    updateForm,
    createForm,
    addEvidence,
    deleteForm
} from "@/utils/apiRequest.js";
// General

const constOther = "other"

const bracketsRegex = /(\(([^)]+)\))/g


export const LoadQuestion = (question, answers, final) => {
    let basicAnswers = ["NO", "SI", "SÍ"] // those answer can be inside another answer and will trigget the condition
    if (
        question.dependency == null ||
        question.dependency == "" ||
        question.dependency == "0"
    ) {
        return true;
    }

    if (question.condition == undefined) {
        let dependencyAnswer = answers[question.dependency];
        if ((dependencyAnswer == undefined || answers[question.dependency] == constOther) && (final.get(question.dependency) != undefined && final.get(question.dependency).answer != undefined)) {
            dependencyAnswer = final.get(question.dependency).answer
        }
        if (dependencyAnswer == undefined) {
            return false
        }
        return dependencyAnswer.toUpperCase() == "SI";
    }

    let conditions = question.condition.split(";");
    if (conditions.length == 0) {
        return false;
    }


    let val = false;

    conditions.forEach((condition) => {
        if (answers[question.dependency] != undefined && answers[question.dependency] != constOther) {
            let ans = answers[question.dependency].split(";");
            ans.forEach((cAns) => {
                if (!basicAnswers.includes(condition.toUpperCase()) && cAns.includes(condition)) {
                    val = true;
                }

                if (cAns == condition) {
                    val = true;
                }
            })
        }

        if (
            (answers[question.dependency] == constOther || answers[question.dependency] == undefined) &&
            (final.get(question.dependency) != undefined && final.get(question.dependency).answer != undefined)
        ) {
            let ans = final.get(question.dependency).answer.split(";");

            ans.forEach((cAns) => {
                if (!basicAnswers.includes(condition.toUpperCase()) && cAns.includes(condition)) {
                    val = true;
                }

                if (cAns == condition) {
                    val = true;
                }
            })
        }
    });

    return val;

}

export const loadQuestionFromFinal = (question, final) => {
    let basicAnswers = ["NO", "SI", "SÍ"] // those answer can be inside another answer and will trigget the condition
    if (
        question.dependency == null ||
        question.dependency == "" ||
        question.dependency == "0"
    ) {
        return true;
    }

    if (question.condition == undefined) {
        let dependencyAnswer = final.get(question.dependency).answer
        if (final.get(question.dependency) != undefined && final.get(question.dependency).answer != undefined) {
            dependencyAnswer = final.get(question.dependency).answer
        }
        if (dependencyAnswer == undefined) {
            return false
        }
        return dependencyAnswer.toUpperCase() == "SI";
    }

    let conditions = question.condition.split(";");
    if (conditions.length == 0) {
        return false;
    }

    let val = false;

    conditions.forEach((condition) => {
        if (
            final.get(question.dependency) != undefined && final.get(question.dependency).answer != undefined
        ) {
            let ans = final.get(question.dependency).answer.split(";");

            ans.forEach((cAns) => {
                if (!basicAnswers.includes(condition.toUpperCase()) && cAns.includes(condition)) {
                    val = true;
                }

                if (cAns == condition) {
                    val = true;
                }
            })
        }
    });

    return val;
}

export const updateRegister = async (registro, evidences, questions, answers, final, update) => {
    questions.forEach((sec) => {
        sec.questions.forEach((question) => {
            if (LoadQuestion(question, answers, final)) {
                if (answers[getNum(question)] != constOther) {
                    let val = answers[getNum(question)];
                    if (val == null) {
                        val = final.get(getNum(question)).answer;
                    }
                    final.set(getNum(question), {
                        question: question.question,
                        answer: val,
                    });
                } else {
                    final.set(getNum(question), {
                        question: final.get(getNum(question)).question,
                        answer: final.get(getNum(question)).answer,
                    });
                }
            }
        });
    });

    let updatedList = new Map();
    let newAnswers = [];
    final.forEach((answer) => {
        let update = false;
        let question = answer.question.question;
        if (question == undefined) {
            question = answer.question;
        }
        registro.answers.forEach((ans) => {
            if (updatedList.get(question) != true) {
                if (ans.question == question) {
                    ans.answer = answer.answer;
                    updatedList.set(question, true);
                    update = true;
                    return;
                }
            }
        });
        if (!update) {
            if (answer.answer == "") {
                return;
            }

            if (question != "") {
                let ans = {
                    question: question,
                    answer: answer.answer,
                };
                newAnswers.push(ans);
                updatedList.set(question, true);
                return;
            }
            newAnswers.push(answer);
            updatedList.set(question, true);
        }
    });
    let form = await updateForm(registro);
    if (form.data.status == "success" && newAnswers != []) {
        var formAnswered = await addAnswers(registro.code, newAnswers);
        if (formAnswered.data.status != "success") {
            return;
        }
    }

    var bar = new Promise((resolve) => {
        let count = 0;
        if (evidences.length == 0) {
            resolve();
        }
        evidences.forEach(async (evidence) => {
            var formData = new FormData();
            formData.append("", evidence);
            formData.append("code", form.data.form.code);
            let ans = await addEvidenceToForm(formData);
            count++;
            if (ans.status != 201) {
                return;
            }
            if (count == evidences.length) {
                resolve();
            }
        });
    });

    bar.then(() => {
        update.success = true;
        window.scrollTo(0, 0);
    });

}

export const createRegister = async (questions, answers, final, evidences, liftingDate, fillingResponsable, errors, router) => {
    let answersNumber = 1;
    questions.forEach((sec) => {
        sec.questions.forEach((question) => {
            if (LoadQuestion(question, answers, final)) {
                if (answers[getNum(question)] != constOther) {
                    final.set(getNum(question), {
                        number: answersNumber,
                        question: question.question,
                        answer: answers[getNum(question)],
                        litNumber: question.literalNumber,
                    });
                } else {
                    final.set(getNum(question), {
                        number: answersNumber,
                        question: final.get(getNum(question)).question,
                        answer: final.get(getNum(question)).answer,
                        litNumber: question.literalNumber,
                    });
                }

                answersNumber += 1;
            } else {
                final.delete(getNum(question));
            }
        });
    });

    var cErrors = checkForm(final, errors);
    if (cErrors.arr.length > 0) {
        window.scrollTo(0, 0);
        return;
    }
    let formData = {
        liftingDate: liftingDate,
        fillingResponsable: fillingResponsable,
    };

    let form = await createForm(formData);
    if (form.data.status == "success") {
        var finalAnswers = [];
        final.forEach((answer) => {

            finalAnswers.push(answer);
            if (answer.question == "Observaciones" && (answer.answer == undefined || answer.answer == "")) {
                finalAnswers.pop()
            }

        });
        evidences.forEach((evidence) => {
            var formData = new FormData();
            formData.append("", evidence);
            formData.append("code", form.data.forms.code);
            addEvidenceToForm(formData);
        });

        var formAnswered = await addAnswers(form.data.forms.code, finalAnswers);
        if (formAnswered.data.status == "success") {
            const path = `/registros/${form.data.forms.id}`;
            router.push(path);
            return;
        }

        await deleteForm(form.data.forms.code);
    }
}

export const checkForm = (final, errors) => {
    errors.arr = []
    final.forEach((answer) => {
        if (
            (answer.answer == null || answer.answer == "" || answer.answer == undefined || answer.answer.includes(undefined) || answer.answer.includes("undefined")) &&
            !answer.question.includes("solo por el técnico") && !answer.question.includes("Observaciones")
        ) {
            errors.arr.push(
                "No puede enviar preguntas vacías, por favor, revise nuevamente, si ya la ha respondido, por favor digítela de nuevo: " +
                answer.litNumber + " " + answer.question
            );
        }
    });
    return errors;
}

export const addEvidenceToForm = async (file) => {
    const response = await addEvidence(file);
    if (response.status != 201) {
        console.log("fail");
    }
    return response;
}

export const isSelectQuestion = (question) => {
    return question.type == "select";
}

export const isNumericQuestion = (question) => {
    return question.type == "numeric"
}
export const isTableQuestion = (question) => {
    return question.type.includes("table");
}

export const isDropQuestion = (question) => {
    return question.type == "aux";
}

export const isCheckQuestion = (question) => {
    return question.type.includes("multi");
}

export const isTextQuestion = (question) => {
    return question.type == "text";
}
export const hasSpecifyText = (options) => {
    if (options == null) {
        return false;
    }
    return options.includes("especifique");
}

export const getNum = (question) => {
    return question.section.toString() + "." + question.number;
}

// charts part

const getDropOptions = (text) => {
    let found = text.match(bracketsRegex);
    if ((found != null && found.length) != 0) {
        found[0] = found[0].substring(1, found[0].length - 1);
        return found[0];
    }
    return text;
}

export const getCountInData = (parent, name) => {
    let names = [];
    let values = [];
    switch (name) {
        case "dominios":
            for (let [key, value] of parent.domainsCount) {
                names.push(getDropOptions(key));
                values.push(value);
            }
            break;
        case "subdominios":
            for (let [key, value] of parent.subDomainsCount) {
                names.push(getDropOptions(key));
                values.push(value);
            }

            break;

        case "sectores":
            for (let [key, value] of parent.sectorsCount) {
                names.push(getDropOptions(key));
                values.push(value);
            }

            break;
        case "instituciones":
            for (let [key, value] of parent.institutionsCount) {
                names.push(getDropOptions(key));
                values.push(value);
            }

            break;

        default:
            break;
    }

    let responseData = {
        labels: names,
        values: values,
    };
    return responseData;
}



export const setupGraph = (parent, view) => {
    if (view != "public") {
        parent.chartList.push("general");
    }

    parent.chartList.push("dominios");
    parent.chartList.push("subdominios");
    parent.chartList.push("sectores");
    parent.chartList.push("instituciones");

    let domainsData = getCountInData(parent, "dominios");
    let subDomainsData = getCountInData(parent, "subdominios");
    let sectorsData = getCountInData(parent, "sectores");
    let institutionData = getCountInData(parent, "instituciones");

    parent.combinations.set("general", {
        xAxis: {
            type: "category",
            data: [],
        },
        grid: {
            containLabel: false,
        },
        title: {
            text: "Estatus de los registros administrativos del I.RR.AA",
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
            orient: "vertical",
            left: "right",
            data: ["Aprobados", "En revisión", "Publicados", "Digitados"]
        },
        series: [
            {
                type: "pie",
                name: "datos generales",
                radius: "55%",

                center: ["50%", "50%"],
                data: [
                    { name: "Aprobados", value: parent.approvedCount },
                    { name: "En revisión", value: parent.rejectedCount },
                    { name: "Publicados", value: parent.publishedCount },
                    { name: "Digitados", value: parent.formsCount },
                ],
                color: ['#0307fc', '#FF0000', '#51cc75', '#f2f202'],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    });
    parent.combinations.set("dominios", {
        xAxis: {
            type: "category",
            data: domainsData.labels,
            axisLabel: { interval: 0, rotate: 30 },
        },
        grid: {
            containLabel: true,
        },
        yAxis: {
            type: "value",
        },
        title: {
            text: "Número de registros por dominio",
            left: "center",
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}",
        },
        series: [
            {
                type: "bar",

                name: "Por dominios",
                data: domainsData.values,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    });
    parent.combinations.set("subdominios", {
        xAxis: {
            type: "category",
            data: subDomainsData.labels,
            axisLabel: { interval: 0, rotate: 30 },
        },
        grid: {
            containLabel: true,
        },
        yAxis: {
            type: "value",
        },
        title: {
            text: "Número de registros por subdominios",
            left: "center",
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}",
        },
        series: [
            {
                type: "bar",

                backgroundStyle: {
                    color: "rgba(180, 180, 180, 0.2)",
                },
                name: "Por subdominios",
                data: subDomainsData.values,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    });
    parent.combinations.set("sectores", {
        xAxis: {
            type: "category",
            data: sectorsData.labels,
            axisLabel: { interval: 0, rotate: 30 },
        },
        grid: {
            containLabel: true,
        },
        yAxis: {
            type: "value",
        },
        title: {
            text: "Número de registros por sectores",
            left: "center",
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}",
        },
        series: [
            {
                type: "bar",


                name: "Por sectores",
                data: sectorsData.values,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    });
    parent.combinations.set("instituciones", {
        xAxis: {
            type: "category",
            data: institutionData.labels,
            axisLabel: { interval: 0, rotate: 30 },
        },
        grid: {
            containLabel: true,
        },
        yAxis: {
            type: "value",
        },
        title: {
            text: "Número de registros por instituciones",
            left: "center",
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}",
        },
        series: [
            {
                type: "bar",

                name: "Por instituciones",
                data: institutionData.values,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                    },
                },
            },
        ],
    });
}


export const getAnswer = (form, text) => {
    let ans = form.answers.find((element) => element.question == text);
    if (ans != undefined) {
        return ans.answer;
    }

    return "";
}